/**
 * v3's LAST top-level sidebar entry — no parent group, no children (`DefaultLayout.vue:539-545`,
 * after Compositions and before the array's `.filter`). The app shell reproduces that position by
 * registering this contribution between module 08's report groups and workspace settings.
 *
 * **FIXED — the two keys disagreed.** v3 gated the sidebar entry on
 * `export_hub_one_time_export_limit_` (`:543`) while the page redirected on
 * `export_hub_scheduled_export_limit_` (`DataExport.vue:117`), so an account holding only the
 * one-time entitlement saw the link and was bounced to Summary on click. Nav and route now read
 * the SAME key (ORP-18753 AC: "Nav entry gated by the same key").
 */
export const dataExportNavItems = [
  {
    labelKey: 'dataExport.nav.label',
    icon: 'folder',
    to: { name: 'DataExport' },
    navKey: 'dataExport',
    // Literal-narrowed so app wiring verifies this inferred contribution against `NavItem`
    // without reversing the enforced app -> feature dependency direction for a type import.
    visibility: { control: 'permission' as const, id: ['export_hub_scheduled_export_limit_'] },
  },
]
